import * as React from 'react';
import { useSelector } from 'react-redux';

import { EmptyPageContainer } from '../EmptyPage';
import { selectIds } from '../../selectors/ids';
import { Main } from '../../components/Main';
import { TableContainer } from '../Table';
import { selectComparePageType, selectIsDesktop } from '../../selectors/page';
import { MobilePageContainer } from '../MobilePage';
import { PageTitleContainer } from '../PageTitle';
import { ControlsContainer } from '../Controls';
import { PageLoaderContainer } from '../PageLoader';
import { CompareHubPageContainer } from '../CompareHubPage';
import { NewbuildingsComparePageContainer } from '../NewbuildingsComparePage';

export const PageContainer: React.FC = () => {
  const comparePageType = useSelector(selectComparePageType);
  const ids = useSelector(selectIds);
  const idsAvailable = ids.length > 0;
  const isDesktop = useSelector(selectIsDesktop);

  if (!isDesktop) {
    return <MobilePageContainer />;
  }

  if (comparePageType === 'hub') {
    return <CompareHubPageContainer />;
  }

  if (comparePageType === 'newbuildings') {
    return <NewbuildingsComparePageContainer />;
  }

  if (!idsAvailable) {
    return <EmptyPageContainer />;
  }

  return (
    <Main>
      <PageTitleContainer />
      <ControlsContainer />
      <TableContainer />
      <PageLoaderContainer />
    </Main>
  );
};
